import React from "react";
import { isEmpty } from "lodash";
import moment from "moment";
const months = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12",
};

// Task 24694 - "what is NaN". Reported on Settings > Billing, where a cell read
// "NaN undefined NaN, Invalid date". That string is what these formatters
// produce for ANY value that is a non-empty string but not a parseable date -
// "0000-00-00 00:00:00" being the common one out of MySQL.
//
//   new Date("0000-00-00 00:00:00")  -> Invalid Date
//   .getDate()                       -> NaN
//   monthNames[NaN]                  -> undefined
//   .getFullYear()                   -> NaN
//   moment(...).format("hh:mm A")    -> "Invalid date"
//
// lodash isEmpty() does not catch it: the string is not empty, it is just not a
// date. So every formatter here now checks the PARSED value as well, and
// renders nothing when it will not parse.
//
// Nothing, rather than a dash or "Unknown": these are used in dozens of table
// cells and inline spans, and an empty cell is already how this component
// behaves for a genuinely absent date. Printing something new would change
// every one of those screens for a case that is always a data problem.
const isUnparseable = (received_date) =>
  Number.isNaN(new Date(received_date).getTime());

const HandleDateTime = (received_date) => {
  if (isEmpty(received_date)) return;
  if (isUnparseable(received_date)) return;
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = new Date(received_date);
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  const time = moment(received_date).format("hh:mm A");
  const date2 = `${day} ${monthNames[monthIndex]} ${year}`;

  return (
    <>
      {received_date && (
        <div>
          <span className={"create-date-day-month-year"}>{date2},</span>
          <span className={"created-date-time"}> {time}</span>
        </div>
      )}
    </>
  );
};
export const HandleDateNoStyling = (received_date) => {
  if (isEmpty(received_date)) return;
  if (isUnparseable(received_date)) return;
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = new Date(received_date);
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  const time = moment(received_date).format("hh:mm A");
  const date2 = `${day} ${monthNames[monthIndex]} ${year}`;

  return <>{received_date && <span>{date2}</span>}</>;
};

export default HandleDateTime;
export const HandleDate = (received_date, style) => {
  if (isEmpty(received_date)) return;
  if (isUnparseable(received_date)) return;
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const date = new Date(received_date);
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const date2 = `${day} ${monthNames[monthIndex]} ${year}`;

  return (
    <>
      {received_date && (
        <div>
          <span
            className={
              style === "dontStyle" ? "" : "create-date-day-month-year"
            }
          >
            {date2}
          </span>
        </div>
      )}
    </>
  );
};
const monthNames = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const HandleTime = (received_date) => {
  if (isEmpty(received_date)) return;
  if (isUnparseable(received_date)) return;

  const date = new Date(received_date);
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();
  const time = moment(received_date).format("hh:mm A");
  const date2 = `${day} ${monthNames[monthIndex]} ${year}`;

  return (
    <>
      {received_date && (
        <div>
          <span className={"created-date-time"}> {time}</span>
        </div>
      )}
    </>
  );
};

export function handleDateFormat(e) {
  // received format [Wed Dec 14 2022 00:00:00 GMT+0000 (Greenwich Mean Time)] change to 2022-12-14
  // convert month name to number
  if (!e) return;
  const month_to_number = (month) => {
    const months = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };
    return months[month];
  };

  const receivedDate = e?.toString();
  const date = receivedDate?.split(" ");
  const year = date[3];
  const month = date[1];
  const day = date[2];
  return `${year}-${month_to_number(month)}-${day}`;
}
export function handleDateFormatInRevere(e) {
  // received format [Wed Dec 14 2022 00:00:00 GMT+0000 (Greenwich Mean Time)] change to 14-12-2022
  // convert month name to number
  if (!e) return;
  const month_to_number = (month) => {
    const months = {
      Jan: "01",
      Feb: "02",
      Mar: "03",
      Apr: "04",
      May: "05",
      Jun: "06",
      Jul: "07",
      Aug: "08",
      Sep: "09",
      Oct: "10",
      Nov: "11",
      Dec: "12",
    };
    return months[month];
  };

  const receivedDate = e?.toString();
  const date = receivedDate?.split(" ");
  const year = date[3];
  const month = date[1];
  const day = date[2];
  return `${day}-${month_to_number(month)}-${year}`;
}
export function timeFormatDateAndTime(newDate) {
  let date;
  if (newDate) {
    date = new Date(newDate);
  } else {
    date = new Date();
  }
  return (
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) +
    // (date.getMonth() + 1) +
    "-" +
    (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate()) +
    // date.getDate() +
    " " +
    (date.getHours() <= 9 ? "0" + date.getHours() : date.getHours()) +
    // date.getHours() +
    ":" +
    (date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes()) +
    // date.getMinutes() +
    ":" +
    (date.getSeconds() <= 9 ? "0" + date.getSeconds() : date.getSeconds())
  );
}
export function timeFormatDateAndTimeNoSeconds(newDate) {
  let date;
  if (newDate) {
    date = new Date(newDate);
  } else {
    date = new Date();
  }
  return (
    date.getFullYear() +
    "-" +
    (date.getMonth() + 1 <= 9
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) +
    // (date.getMonth() + 1) +
    "-" +
    (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate()) +
    // date.getDate() +
    " " +
    (date.getHours() <= 9 ? "0" + date.getHours() : date.getHours()) +
    // date.getHours() +
    ":" +
    (date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes())
    // date.getMinutes() +
  );
}
export function timeFormatDateAndTimeNoTime(newDate) {
  let date;
  if (newDate) {
    date = new Date(newDate);
  } else {
    date = new Date();
  }
  return (
    (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate()) +
    "-" +
    monthNames[date.getMonth()] +
    // (date.getMonth() + 1) +
    "-" +
    date.getFullYear()
  );
}

export function dateFormatReverse(date) {
  if (isEmpty(date)) {
    // if date is empty return todays day
    const newDate = new Date();
    const splitNewDate = newDate.toString().split(" ");
    const splitNewDate2 = splitNewDate.toString().split("-");
    const year = splitNewDate2[0];
    const month = splitNewDate2[1];
    const day = splitNewDate2[2];
    return `${year} ${month} ${day}`;
  }
  const dateArray = date?.split(" ");
  const dateArray2 = dateArray[0]?.split("-");
  const year = dateArray2[0];
  const month = dateArray2[1];
  const day = dateArray2[2];
  return `${year} ${month} ${day}`;
}

export function handleValidDateTime(date) {
  const date1 = new Date(date);
  return moment(date1).format("YYYY-MM-DD HH:mm:ss");
}

export function RestructuredDate(ReceivedDate) {
  return moment(ReceivedDate).format("DD-MM-YYYY");
}

export const flatPickerConvertRawToFormatedDateAndTime = (date) => {
  // Accepts a JS Date / moment (MUI-picker migration) OR a flatpickr
  // selectedDates array (legacy call-sites). IMPORTANT: lodash isEmpty(<Date>)
  // returns TRUE, so we must normalise to a single value BEFORE guarding —
  // otherwise a single Date is treated as empty and this returns undefined,
  // which silently blanks the field it feeds.
  const raw = Array.isArray(date) ? date[0] : date;
  if (!raw) return;
  // raw.toString() => "Wed Feb 14 2024 12:15:00 GMT+0000 (…)"
  // convert to 2024-02-14 12:15:00
  const newDate = raw.toString().split(" ");
  const year = newDate[3];
  const month = months[newDate[1]];
  const day = newDate[2];
  const time = newDate[4];

  return `${year}-${month}-${day} ${time}`;
};
